import { jsx } from "react/jsx-runtime";
import { Tooltip, AnchorButton } from "@blueprintjs/core";
import React from "react";
import {
  DataTable,
  withSelectedEntities,
  createCommandMenu
} from "@teselagen/ui";
import getCommands from "../../commands";
import { map } from "lodash-es";
import { getRangeLength } from "@teselagen/range-utils";
import { connectToEditor } from "../../withEditorProps";
import { compose } from "recompose";
import selectors from "../../selectors";
import { getMassOfAaString } from "@teselagen/sequence-utils";
import { translationsSubmenu } from "../../MenuBar/viewSubmenu";
import { getVisFilter } from "./GenericAnnotationProperties";
import { getMemoOrfs } from "./utils";
class TranslationProperties extends React.Component {
  constructor(props) {
    super(props);
    this.commands = getCommands(this);
  }
  onRowSelect = ([record]) => {
    if (!record) return;
    const { dispatch, editorName } = this.props;
    dispatch({
      type: "SELECTION_LAYER_UPDATE",
      payload: record,
      meta: {
        editorName
      }
    });
  };
  render() {
    const {
      readOnly,
      translations,
      translationPropertiesSelectedEntities,
      deleteTranslation,
      sequenceLength,
      selectedAnnotationId,
      annotationVisibility
    } = this.props;
    const translationsToUse = map(translations, (translation) => {
      let aaString = "";
      for (let i = 0; i < translation.aminoAcids.length; i++) {
        aaString += translation.aminoAcids[i].aminoAcid?.value || "";
      }
      return {
        ...translation,
        sizeBps: getRangeLength(translation, sequenceLength),
        sizeAa: translation.translationType === "ORF" ? Math.floor(getRangeLength(translation, sequenceLength) / 3 - 1) : Math.floor(getRangeLength(translation, sequenceLength) / 3),
        ...translation.strand === void 0 && {
          strand: translation.forward ? 1 : -1
        },
        mass: getMassOfAaString(aaString, 2, true)
      };
    });
    return /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column" }, children: /* @__PURE__ */ jsx(
      DataTable,
      {
        withCheckboxes: true,
        noPadding: true,
        onRowSelect: this.onRowSelect,
        selectedIds: selectedAnnotationId,
        formName: "translationProperties",
        noRouter: true,
        compact: true,
        topLeftItems: getVisFilter(
          createCommandMenu(translationsSubmenu, this.commands, {
            useTicks: true
          })
        ),
        leftOfSearchBarItems: !readOnly && /* @__PURE__ */ jsx(
          Tooltip,
          {
            content: translationPropertiesSelectedEntities.length && translationPropertiesSelectedEntities[0].translationType !== "User Created" ? `Only "User Created" translations can be deleted` : void 0,
            children: /* @__PURE__ */ jsx(
              AnchorButton,
              {
                onClick: () => {
                  deleteTranslation(translationPropertiesSelectedEntities);
                },
                intent: "danger",
                icon: "trash",
                style: { marginLeft: 10, marginRight: 15, height: 30 },
                disabled: !translationPropertiesSelectedEntities.length || translationPropertiesSelectedEntities[0].translationType !== "User Created"
              }
            )
          }
        ),
        annotationVisibility,
        hideSelectedCount: true,
        noFooter: true,
        noFullscreenButton: true,
        isInfinite: true,
        schema: {
          fields: [
            {
              path: "translationType",
              displayName: "Type",
              type: "string"
            },
            {
              path: "sizeAa",
              displayName: "Size (aa)",
              type: "number"
            },
            {
              path: "mass",
              displayName: "Mass (g/mol)",
              type: "number"
            },
            { path: "strand", type: "number" }
          ]
        },
        entities: translationsToUse
      }
    ) });
  }
}
export default compose(
  connectToEditor((editorState) => {
    const { readOnly, annotationVisibility = {}, sequenceData } = editorState;
    return {
      readOnly,
      translations: selectors.translationsSelector(editorState),
      orfs: getMemoOrfs(editorState),
      annotationVisibility,
      sequenceLength: (sequenceData.sequence || "").length,
      sequenceData
    };
  }),
  withSelectedEntities("translationProperties")
)(TranslationProperties);
